/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, TOBI){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname;

	// <地方別リスト>
	if($('#page_res-area').length) {
		const noLink = 'nolink';

		// 0件の場合、県ごと非表示
		$('.js-pref').each((idx, ele) => {
			if(!$(ele).next('.js-pref-tbl').find('tr').length) {
				$(ele).next('.js-pref-tbl').remove();
				$(ele).remove();
			}
		});
		// 表示する件が無い場合、地方ごと非表示
		$('.js-section').each((idx, ele) => {
			let $thisID = $(ele).children('.js-section-head').attr('id');

			if(!$(ele).find('.js-pref').length) {
				$('.js-areaBtn[href="#'+ $thisID +'"]').addClass(noLink).css('cursor','default').css('pointer-events','none');
				$(ele).remove();
			}
		});
	}

	// <子カテゴリ一覧>
	if($('.js-category').length) {
		// サイドナビのカレント
		const $cat = $map.split('/')[2];
		$('body').attr('id', 'page_res-'+$cat);
	}

	// <詳細ページ>


})(window.jQuery, window.TOBI);
